/**
 * Keep only the files matching an `<input accept>`-style list
 * (`image/*,application/pdf,.md`). An empty / wildcard accept keeps everything.
 */
export function filterFilesByAccept(
  files: Iterable<File>,
  accept?: string
): File[] {
  const fileArray = Array.from(files);
  if (!accept || accept === '*' || accept === '*/*') return fileArray;

  const acceptTypes = accept
    .split(',')
    .map((s) => s.trim())
    .filter(Boolean);

  // A file with no MIME type (HEIC on some browsers, unknown extensions) is
  // kept: the downstream validation reports unsupported types with a toast,
  // whereas dropping it here would make the file vanish silently.
  return fileArray.filter((file) =>
    file.type === '' ||
    acceptTypes.some((type) => {
      if (type.endsWith('/*')) {
        return file.type.startsWith(type.slice(0, -1));
      }
      if (type.startsWith('.')) {
        return file.name.toLowerCase().endsWith(type.toLowerCase());
      }
      return file.type === type;
    })
  );
}
